// extracted by mini-css-extract-plugin
export default {"wrapper":"ChapterNavigationCard_wrapper__wNrtt","title":"ChapterNavigationCard_title__4h5fT","description":"ChapterNavigationCard_description__eY9XH"};